import {
  BONUS_RESPONSE, BONUS_SPIN_RESPONSE, BONUS_WIN_STATE,
  FREE_SPIN_COUNT_STATE,
  GAME_APPLICATION_SCENE_STATE, MULTIPLIER_STATE,
  TOTAL_WIN_STATE,
} from '../../stateManagment';
import { gameService } from '../apiServices/GameService';
import { gameAnimations } from './GameAnimationService';
import { bigWinService } from './BigWinService';
import { delay } from 'bog-arcade-core-ui/helpers';
import { ballDrawer } from '../../elementDrawers/balls/BallDrawer';
import { backgroundDrawer } from '../../elementDrawers/background/BackgroundDrawer';
import { BallType, GameSceneType } from '../../core/enums';
import { userService } from './UserService';
import { popupService } from './PopupService';
import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';
import { gamePadService } from './GamePadService';
import { historyHelperService } from './HistoryHelperService';
import { soundService } from './SoundService';


export class BonusSpinService {
  constructor() {
    bigWinService.setBonusSpinPause(() => bonusSpinService.pause());
    bigWinService.setBonusSpinResume(() => bonusSpinService.resume());
    this.request = null;
    this.currentWinAmount = 0;
    this.spinStarted = false;
    this._bonusActiveState = new BehaviorSubject(false);
  }

  setBonusActiveState(value) {
    this._bonusActiveState.next(value);
  }

  get bonusSpinState() {
    return this._bonusActiveState.getValue();
  }

  start() {
    gamePadService.disableAll();
    this.setBonusActiveState(true);
    this._bonusChain();
  }

  resume() {
    this.start();
  }

  pause() {
    this.setBonusActiveState(false);
  }

  end() {
    delay(() => {
      if (this.totalWin) {
        popupService.openCongratulationsPopup();
      } else {
        popupService.closeCongratulationsPopup();
      }
      TOTAL_WIN_STATE.next(this.totalWin);
      if (!gameService.isRealMode) {
        userService.plusBalance(TOTAL_WIN_STATE.getValue());
      } else {
        userService.holdUpdateBalance();
      }
      historyHelperService.add({
        time: new Date().toISOString(),
        betAmount: gamePadService.quickBet,
        winAmount: TOTAL_WIN_STATE.getValue(),
        odd: MULTIPLIER_STATE.getValue(),
        bonus: gameService.isBonus,
      });
      GAME_APPLICATION_SCENE_STATE.next(GameSceneType.main);
      this.setBonusActiveState(false);
    }, 2000);
  }


  _bonusChain() {
    if (this.bonusSpinState && this.getFreeSpinCount() && !this.spinStarted) {
      gameService.bonusSpin().then((res) => {
        BONUS_SPIN_RESPONSE.next(res);
        this.totalWin = res.totalWinAmount;
        this.spinStarted = true;
        delay(() => {
          soundService.playDragonSound();
        }, 600)
        gameAnimations.dragonSoulDracarys().then(() => {
          gameAnimations.dragonSoulLoop();
          this.decrementFreeSpin();
        });
        delay(() => {
          if (!res.odd) {
            this.spinStarted = false;
            ballDrawer.application.breakBonusBalls(res).then(() => {
              delay(() => {
                this._bonusChain();
              }, 1000);
            });
          } else {
            if (res.result.multiplier.odd) {
              gameAnimations.breakBallBoom();
              ballDrawer.application.breakBonusBall()
                .then(() => {
                  backgroundDrawer.application.setMultiplierAnimation(res.result.multiplier.odd)
                    .then(() => {
                      ballDrawer.application.setBall(BallType.bonus);
                    });
                });
            } else {
              ballDrawer.application.crackBall(res.result.multiplier.crackedCount);
            }
            ballDrawer.application.breakBonusBalls(res).then(() => {
              ballDrawer.application.setAdditionalBalls().then(() => {
                if (res.winAmount) {
                  BONUS_WIN_STATE.next(res.winAmount);
                }
                if (bigWinService.check(res)) {
                  delay(() => {
                    bigWinService.start();
                  }, 1500);
                }
                this.spinStarted = false;
                delay(() => {
                  this._bonusChain();
                }, 3000);
              });
            });
          }
        }, 1600);
      })
        .catch(error => {
          bonusSpinService.setError(error);
          gameService.getBonusLastState().then(data => {
            if (data) {
              this._bonusChain();
            } else {
              GAME_APPLICATION_SCENE_STATE.next(GameSceneType.main);
            }
          }).catch(() => {
            window.location.reload();
          });
        });
    }
    if (!this.getFreeSpinCount() && !bigWinService.state) {
      this.end();
    }
  }

  /**
   * @name setData
   * @param {Object} data
   * @param {string} data.demoBonusId
   * @param {number} data.result
   * @param {number} data.winAmount
   */
  setData(data) {
    BONUS_RESPONSE.next(data);
  }

  /**
   *
   * @return {void}
   */

  decrementFreeSpin() {
    FREE_SPIN_COUNT_STATE.next(FREE_SPIN_COUNT_STATE.getValue() - 1);
  }

  getFreeSpinCount() {
    return FREE_SPIN_COUNT_STATE.getValue();
  }

  resetError() {
    this.spinError = null;
  }

  setError(error) {
    this.spinError = error;
  }
}

export const bonusSpinService = new BonusSpinService();
